import React, { Component } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import YouTube from 'react-youtube';
import Vimeo from '@u-wave/react-vimeo';
import _actions from '../../actions';
import ValidatedInput from '../forms/ValidatedInput';
import i18n from '../../i18n';
import Video from '../svg/Video';

class VideoContentEditor extends Component {
    static isYouTube(url) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length === 11) ? { isYouTube: true, embedId: match[7] } : { isYouTube: false, embedId: '' };
    }

    static isVimeo(url) {
        // eslint-disable-next-line no-useless-escape
        const regExp = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/?(showcase\/)*([0-9))([a-z]*\/)*([0-9]{6,11})[?]?.*/;
        const match = url.match(regExp);
        return match && match.length === 7 ? { isVimeo: true, videoId: match[6] } : { isVimeo: false, videoId: '' };
    }

    constructor(props) {
        super();
        let videoType;
        let embedId;
        const ytResult = VideoContentEditor.isYouTube(props.contentModalContent.videoUrl);
        const vimeoResult = VideoContentEditor.isVimeo(props.contentModalContent.videoUrl);
        if (ytResult.isYouTube) {
            videoType = 1;
            embedId = ytResult.embedId;
        } else if (vimeoResult.isVimeo) {
            videoType = 2;
            embedId = vimeoResult.videoId;
        } else {
            videoType = 3;
        }
        this.state = {
            videoCanPlay: false,
            videoUrl: props.contentModalContent.videoUrl,
            loading: props.contentModalContent.videoUrl.length > 0,
            videoFailed: false,
            videoType,
            embedId,
            isMP4: true,
        };

        this.videoCanPlay = this.videoCanPlay.bind(this);
        this.videoCantPlay = this.videoCantPlay.bind(this);
        this.urlChanged = this.urlChanged.bind(this);
    }

    videoCanPlay() {
        this.setState({ videoCanPlay: true, loading: false });
        this.props.setStateFromEvent({ target: { value: true } }, 'isUrlValid');
        this.props.setStateFromEvent({ target: { value: this.state.videoUrl } }, 'videoUrl');
    }

    videoCantPlay() {
        this.setState({
            videoCanPlay: false, loading: false, videoFailed: true, videoType: null,
        });
        this.props.setStateFromEvent({ target: { value: false } }, 'isUrlValid');
    }

    urlChanged(evt) {
        this.setState({ videoFailed: false, videoType: null });
        const isYT = VideoContentEditor.isYouTube(evt.target.value);
        if (isYT.isYouTube) {
            // eslint-disable-next-line object-curly-newline
            this.setState({ videoCanPlay: false, loading: true, videoUrl: `https://www.youtube.com/embed/${isYT.embedId}`, embedId: isYT.embedId, videoType: 1 });
            this.props.setStateFromEvent(1, 'videoType');
            return this.props.setStateFromEvent(evt, 'videoUrl');
        }
        const isVimeo = VideoContentEditor.isVimeo(evt.target.value);
        if (isVimeo.isVimeo) {
            // eslint-disable-next-line object-curly-newline
            this.setState({ videoCanPlay: false, loading: true, videoUrl: `https://player.vimeo.com/video/${isVimeo.videoId}?title=0&byline=0&portrait=0`, embedId: isVimeo.videoId, videoType: 2 });
            this.props.setStateFromEvent(2, 'videoType');
            return this.props.setStateFromEvent(evt, 'videoUrl');
        }

        const filename = evt.target.value;
        const extension = filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;

        if (extension.toUpperCase() === 'MP4') {
            // eslint-disable-next-line object-curly-newline
            this.setState({ videoCanPlay: false, loading: true, videoUrl: evt.target.value, videoType: 3, isMP4: true });
            const mp4Element = document.getElementById('edit-content-modal-video');
            if (mp4Element != null) {
                mp4Element.src = String(evt.target.value);
                mp4Element.load();
            }
            this.props.setStateFromEvent(3, 'videoType');
            return this.props.setStateFromEvent(evt, 'videoUrl');
        }
        // if it wasn't an mp4, unload the video element
        // eslint-disable-next-line object-curly-newline
        this.setState({ videoCanPlay: false, loading: false, videoUrl: evt.target.value, videoType: null, isMP4: false });
        const mp4Element = document.getElementById('edit-content-modal-video');
        if (mp4Element != null) {
            mp4Element.pause();
            mp4Element.removeAttribute('src');
            if (mp4Element.firstChild) mp4Element.removeChild(mp4Element.firstChild);
            mp4Element.load();
        }

        return this.props.setStateFromEvent({ target: { value: false } }, 'isUrlValid');
    }

    render() {
        const ytOpts = {
            height: '202',
            width: '360',
        }; // this.state.videoType === 3 && !this.state.isMP4 && this.state.videoUrl.length !== 0

        return (
            <div className="edit-text-content">
                <span className="preview">Preview</span>
                <div className="preview-block-video">
                    {this.state.videoType !== 1 && this.state.videoType !== 2 && this.state.videoType !== 3
                        && (
                            <div className="preview-box"><div className="play"><Video color="#a9a9a9" /></div></div>
                        )}
                    {this.state.videoType === 3
                        && (
                            <video id="edit-content-modal-video" width="360px" style={!this.state.loading && this.state.videoCanPlay ? {} : { visibility: 'hidden' }} controls onCanPlay={this.videoCanPlay} onError={this.videoCantPlay}>
                                <source src={this.props.contentModalContent.videoUrl} type="video/mp4" />
                            </video>
                        )}
                    {this.state.videoType === 1
                        && (
                            <YouTube
                                videoId={this.state.embedId}
                                id="edit-content-modal-video-youtube"
                                className="taco"
                                containerClassName="containerTaco"
                                opts={ytOpts}
                                onReady={this.videoCanPlay}
                                onError={this.videoCantPlay}
                            />
                        )}
                    {this.state.videoType === 2 && this.state.videoFailed === false
                        && (
                            <Vimeo
                                video={this.state.embedId}
                                id="edit-content-modal-video-vimeo"
                                width="360px"
                                height="202px"
                                className="taco"
                                color="ffffff"
                                onReady={this.videoCanPlay}
                                onError={this.videoCantPlay}
                            />
                        )}
                </div>
                <div className="text-input-wrapper">
                    <ValidatedInput
                        containerClass="input_videoUrl"
                        labelText="Video Embed Link"
                        value={this.props.contentModalContent.videoUrl}
                        name="videoUrl"
                        onChange={(e) => { this.urlChanged(e); }}
                        errorMessage={i18n.t('content.validation.video-url-invalid')}
                        hasError={(!this.state.videoCanPlay && this.props.contentModalContent.videoUrl.length > 0 && !this.state.loading) || (this.state.videoType === 3 && !this.state.isMP4 && this.state.videoUrl.length > 0)}
                        successMessage=""
                        hasSuccess={false}
                    />
                </div>
                <div className="check-rec">
                    <label
                        data-qa="form-full-width-label"
                        id="form-full-width__label"
                    >
                        <input
                            data-qa="form-full-width-checkbox"
                            id="form-full-width"
                            defaultChecked={this.props.contentModalContent.isFullWidth}
                            onChange={(e) => { return this.props.setStateFromEvent(e, 'isFullWidth'); }}
                            type="checkbox"
                        />
                        <span className={this.props.contentModalContent.isFullWidth === false ? 'checkbox-rec empty' : 'checkbox-rec checked'} />
                        <span className="form-full-width">
                            Extend video frame the full width of the screen
                        </span>
                    </label>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(VideoContentEditor);
